module.exports = __webpack_public_path__ + "static/media/nica.b6e27792.jpg";